"use client";

import React from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";

import { FooterSocialLinksItemProps } from "~/bff/components/FooterSocialLinksItem";

import { LinkItem } from "../link-item/component";

import { GroupedLinksColumnMobileContainer } from "./styled";

interface GroupedLinksColumnMobileProps {
  headline?: string;
  links?: (FooterSocialLinksItemProps | undefined)[];
  shouldOpenAllLinksInNewTab?: boolean;
}

export const GroupedLinksColumnMobile: React.FC<GroupedLinksColumnMobileProps> = ({
  headline,
  links,
  shouldOpenAllLinksInNewTab,
}) => {
  const idValue = headline?.replace(" ", "-").toLowerCase();

  return (
    <GroupedLinksColumnMobileContainer
      item
      xs={12}
      sm={12}
      id={`footer-accordion-section-${idValue}`}
    >
      <Accordion>
        <AccordionSummary>
          <Typography>{headline?.toUpperCase()}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List sx={{ p: 0 }}>
            {links?.map((el, index) => (
              <LinkItem
                key={index}
                link={el?.link}
                target={shouldOpenAllLinksInNewTab ? "_blank" : undefined}
              />
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    </GroupedLinksColumnMobileContainer>
  );
};
